type FormsConfig = {
  googleKey: string;
  url: string;
};

const host = window.location.hostname;
let configs: FormsConfig;

const defaultConfig: FormsConfig = {
  googleKey: '',
  url: 'https://qa.ngw6formsfa.svc.vwusa.io',
};

if (host.startsWith('vw')) {
  configs = {
    ...defaultConfig,
    url: 'https://prod.ngw6formsfa.svc.vwusa.io',
  };
} else {
  configs = {
    ...defaultConfig,
  };
}

export const configJson = configs;
